<template>
  <router-view />
</template>

<script>
export default {
  name: 'trainings-page-container',
};
</script>
